// @ts-nocheck

/**
 * saw-product-form - Variant selection & subscription (selling plan) or one-time add to cart
 */

(function() {
  u_FormatMoney = (cents, format = '${{amount}}') => {
    if (typeof cents == 'string') cents = cents.replace('.', '');
    var v = '', r = /\{\{\s*(\w+)\s*\}\}/, f = format || this.money_format;
    var d = (o, def) => (typeof o == 'undefined' ? def : o);
    var fm = (n, p, t, dec) => {
      p = d(p, 2); t = d(t, ','); dec = d(dec, '.');
      if (isNaN(n) || n == null) return 0;
      n = (n / 100).toFixed(p);
      var x = n.split('.'), $ = x[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + t), c = x[1] ? dec + x[1] : '';
      return $ + c;
    };
    var m = f.match(r);
    if (m) switch (m[1]) {
      case 'amount': v = fm(cents, 2); break;
      case 'amount_no_decimals': v = fm(cents, 0); break;
      case 'amount_with_comma_separator': v = fm(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = fm(cents, 0, '.', ','); break;
    }
    return f.replace(r, v);
  };
  
  document.addEventListener('alpine:init', () => {
    Alpine.data('ProductCustomWidget', () => ({
      form_id: '',
      product: null,
      currentVariant: null,
      sellingPlanId: null,
      subscriptionType: 'subscribe',
      init() {
        this.product = JSON.parse(this.$el.dataset.product);
        this.currentVariant = JSON.parse(this.$el.dataset.currentVariant);
        this.sellingPlanId = this.u_GetDefaultSellingPlanId();

        this.SetProductFormVariables();
        this.$watch('subscriptionType', this.SetProductFormVariables.bind(this));

        // get form id from data attribute
        let $addtocart = this.$el.closest('.product-details').querySelector('.shopify-product-form');
        if ($addtocart) this.form_id = $addtocart.getAttribute('id');

        this.$nextTick(() => {
          requestAnimationFrame(() => this.u_ScrollQuantityRowToSelected());
        });
      },

      u_ScrollQuantityRowToSelected() {
        if (!window.matchMedia('(max-width: 990px)').matches) return;
        let row = this.$el.querySelector('.saw-variant-option--quantity-cards .saw-variant-options');
        if (!row || row.scrollWidth <= row.clientWidth) return;
        let input = row.querySelector('input[type="radio"]:checked');
        if (!input) return;
        let item = input.closest('option-value');
        if (!item) return;
        item.scrollIntoView({ behavior: 'auto', inline: 'center', block: 'nearest' });
      },
      get isSubscription() {
        return this.subscriptionType === 'subscribe';
      },
      get ProductSellingPlans() {
        return this.product.selling_plan_groups[0].selling_plans;
      },
      get CurrentVariantSellingPlans() {
        let selling_plans = this.currentVariant.selling_plan_allocations.map(item => {
          let plan = this.ProductSellingPlans.find(plan => plan.id == item.selling_plan_id);
          if (!plan) return null;
          plan.name = plan.name.trim();
          return { ...item, ...plan };
        }).filter(plan => plan !== null);
        return selling_plans;
      },
      get SelectedSellingPlan() {
        return this.CurrentVariantSellingPlans.find(plan => plan.id == this.sellingPlanId);
      },
      get isSubscription() {
        return this.subscriptionType === 'subscribe';
      },
      get BoxSize() {
        let box_size = 1;
        if (this.currentVariant.title.toLowerCase().includes('1 box')) {
          box_size = 1;
        }
        else if (this.currentVariant.title.toLowerCase().includes('2 boxes')) {
          box_size = 2;
        }
        else if (this.currentVariant.title.toLowerCase().includes('3 boxes')) {
          box_size = 3;
        }
        return box_size;
      },

      get FooterPriceCents() {
        if (!this.currentVariant) return 0;
        if (this.isSubscription && this.SelectedSellingPlan) return this.SelectedSellingPlan.price;
        if (this.isSubscription) {
          let a = this.currentVariant.selling_plan_allocations;
          return a && a.length ? a[0].price : this.currentVariant.price;
        }
        return this.currentVariant.price;
      },

      get FooterBundleSavings() {
        let oneBox = this.product.variants.find(v => v.title && v.title.includes('1 Box'));
        if (!oneBox || !this.currentVariant) return 0;
        let qty = this.BoxSize;
        if (qty < 1) return 0;
        if (this.isSubscription) {
          let plan = this.SelectedSellingPlan;
          if (!plan) return 0;
          return Math.max(0, oneBox.price * qty - plan.price);
        }
        let unitPrice = this.currentVariant.price / qty;
        return Math.max(0, Math.floor(oneBox.price - unitPrice) * qty);
      },

      u_GetDefaultSellingPlanId() {
        let plans = this.CurrentVariantSellingPlans;
        if (!plans.length) return null;

        let oneMonthPlan = plans.find(plan => /(^|\b)1\s*month(s)?\b/i.test(plan.name || ''));
        return oneMonthPlan ? oneMonthPlan.id : plans[0].id;
      },

      get ImagesByVariant() {
        let media = this.product.media;
        let media_by_variant = media.filter(media => {
          if (!media.alt) {
            media.alt = '';
            return true;
          }
          let media_type = media.alt.split('|||')[0];
          let media_variant_sku = media_type.split('--')[1];
          if (!media_type || !media_variant_sku || !this.currentVariant.sku) return false;
          return !!media_type && media_type.includes('variant') && media_variant_sku.includes(this.currentVariant.sku);
        });
        let media_lifestyle = media.filter(media => {
          let media_type = media.alt.split('|||')[0];
          if (!media_type) return false;
          return media_type.includes('lifestyle');
        });
        let images = [...media_by_variant, ...media_lifestyle];
        return images;
      },

      e_UpdateSelectedVariant(e) {
        let options = e.currentTarget.querySelectorAll('.saw-variant-options input[type="radio"]');
        let selectedValues = Array.from(options).filter(option => option.checked).map(option => option.value);
        let selectedVariant = this.product.variants.find(variant => variant.options.join('/') == selectedValues.join('/'));
        
        // if variant undefined (due to missing combination)
        if (!selectedVariant) {
          // find the first variant that has the same options as the selected values
          let lastSelected = e.target.value;
          selectedVariant = this.product.variants.find(variant => variant.options.includes(lastSelected));
        }
        // console.log(selectedVariant);

        this.currentVariant = selectedVariant;
        this.sellingPlanId = this.u_GetDefaultSellingPlanId();
        this.u_UpdateUrlHistoryVariant();
        // also dispatch a custom event to indicate variant has changed
        document.dispatchEvent(new CustomEvent('variant:change', {
          detail: { variant: this.currentVariant }
        }));
        this.variantImages = this.ImagesByVariant;

        this.SetProductFormVariables();
      },


      SetProductFormVariables() {
        let $product = this.$el.closest('.product-details');
        let $name_id = $product.querySelector('[name="id"]');
        if ($name_id) $name_id.value = this.currentVariant.id;

        let $selling_plan = $product.querySelector('[name="selling_plan"]');
        if (this.isSubscription) {
          if ($selling_plan) {
            $selling_plan.value = this.sellingPlanId;
          }
          else {
            let input = document.createElement('input');
            input.type = 'hidden';
            input.name = 'selling_plan';
            input.value = this.sellingPlanId;
            $product.appendChild(input);
          }
        }
        else {
          if ($selling_plan) $selling_plan.remove();
        }
      },

      u_UpdateUrlHistoryVariant() {
        let isProductPage = window.location.pathname.includes('/products/');
        if (!isProductPage) return;
        history.pushState(null, '', `/products/${this.product.handle}?variant=${this.currentVariant.id}`);
      },

      u_FormatMoney(cents) {
        return u_FormatMoney(cents);
      },

      u_GetLeadingVariants(option_position, value) {
        let leadingVariants = []
        if (option_position == 1) {
          leadingVariants = this.product.variants.filter(variant => variant.option1 == value);
        }
        else if (option_position == 2) {
          leadingVariants = this.product.variants.filter(variant => variant.option1 == this.currentVariant.option1 && variant.option2 == value);
        }
        else if (option_position == 3) {
          leadingVariants = this.product.variants.filter(variant => variant.option1 == this.currentVariant.option1 && variant.option2 == this.currentVariant.option2 && variant.option3 == value);
        }
        // console.log(option_position, value, leadingVariants);
        return leadingVariants;
      }
    }));
  });
})();